<template>
  <div class="app-container content-information">
    <!--    导航-->
    <div class="navigation edit-demo">
      <el-button size="mini" type="primary-icon-medium" icon="icon-ccui-return" @click="handleBack">返回</el-button>
      <div class="cut-line"/>
      <!-- 面包屑 -->
      <el-breadcrumb class="crumbs-container" separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">模板应用</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/tmpl/demo/demo-list' }">功能模块</el-breadcrumb-item>
        <el-breadcrumb-item>编辑 <span>{{ form.demoName }}</span></el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <!--    主体-->
    <div class="info-form">
      <el-card-title :title="title"/>
      <div class="form-content">
        <el-form ref="form" :model="form" :rules="rules" label-width="100px">
          <el-form-item label="序号：">
            <el-input v-model="form.demoId" class="input-long" placeholder="请输入内容" :disabled="true"/>
          </el-form-item>
          <el-form-item label="名称：" prop="demoName">
            <el-input v-model="form.demoName" class="input-long" placeholder="请输入内容"/>
          </el-form-item>
          <el-form-item label="用户名：" prop="userName">
            <el-input v-model="form.userName" class="input-long" placeholder="请输入用户名"/>
          </el-form-item>
          <el-form-item label="年龄：">
            <el-input v-model="form.age" class="input-long" placeholder="请输入内容"/>
          </el-form-item>
          <el-form-item label="手机号：" prop="phone">
            <el-input v-model="form.phone" class="input-long" @change="financingMinChange" placeholder="请输入内容"/>
          </el-form-item>
          <el-form-item label="单价：">
            <el-input v-model="form.skuPrince" class="input-long" placeholder="请输入内容"/>
          </el-form-item>
          <el-form-item label="库存量：">
            <el-select v-model="form.skuNum" class="input-long" placeholder="请选择库存量" value="">
              <el-option label="10" value="10"></el-option>
              <el-option label="20" value="20"></el-option>
              <el-option label="30" value="30"></el-option>
              <el-option label="40" value="40"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="修改时间：">
            <el-date-picker
              v-model="form.modifyDate"
              type="date"
              placeholder="选择日期"/>
          </el-form-item>
          <el-form-item label="修改人ID：">
            <el-input v-model="form.modifyUserId" class="input-long" placeholder="请输入内容"/>
          </el-form-item>
          <el-form-item label="修改人：">
            <el-input
              type="textarea"
              autosize
              class="input-long"
              placeholder="请输入内容"
              v-model="form.modifyUser">
            </el-input>
          </el-form-item>
          <el-form-item label="是否启用：">
            <el-radio v-model="form.status" :label="0">禁用</el-radio>
            <el-radio v-model="form.status" :label="1">启用</el-radio>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <!--    底部-->
    <div class="bottom-guide">
      <ul class="bottom-button">
        <li>
          <el-button type="bottom" icon="icon-ccui-return" @click="handleBack">返回</el-button>
        </li>
        <li class="bottom-center-solid"></li>
        <li>
          <el-button type="bottom" icon="icon-ccui-save-submit" @click="submitHandle('form')">保存</el-button>
        </li>
        <li>
          <el-button type="bottom" icon="icon-ccui-cancel" @click="resetHandle">取消</el-button>
        </li>
        <li class="bottom-center-solid"></li>
        <li>
          <el-button type="bottom" icon="icon-ccui-copy" @click="handleCopy">复制</el-button>
        </li>
      </ul>
    </div>

  </div>
</template>

<script>
import { editDemo, getDemoById } from '@/api/edit-demo'

export default {
  name: 'NewContract',
  data () {
    var validateMobilePhone = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('负责人手机号不可为空'))
      } else {
        if (value !== '') {
          var reg = /^1[3456789]\d{9}$/
          if (!reg.test(value)) {
            callback(new Error('请输入有效的手机号码'))
          }
        }
        callback()
      }
    }
    return {
      title: '编辑信息',
      form: {
        status: '1',
        demoId: '',
        demoName: '',
        userName: '',
        age: '',
        phone: '',
        skuPrince: '',
        skuNum: '',
        modifyDate: '',
        modifyUserId: '',
        modifyUser: ''
      },
      formOrigin: {},
      rules: {
        demoName: [
          { required: true, message: '请输入名称', trigger: 'blur' },
          { min: 2, max: 5, message: '长度在 2 到 5 个字符', trigger: 'blur' }
        ],
        userName: [
          { required: true, message: '请输用户名', trigger: 'blur' }
        ],
        phone: [
          { required: true, validator: validateMobilePhone, trigger: 'blur' }
        ]
      }
    }
  },
  activated () {
    const id = this.$route.params.demoId
    console.log('路由活跃状态')
    this.getDemoById(id)
  },
  methods: {
    handleCopy () {
      console.log('提交复制信息')
      this.$router.push('/tmpl/demo/demo-copy/' + this.form.demoId)
    },
    resetHandle () {
      console.log('重置编辑信息')
      // this.form = {}
      // this.form = this.formOrigin
      this.form = Object.assign({}, this.form, this.formOrigin)
    },
    submitHandle (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.editDemo()
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    financingMinChange () {

    },
    editDemo () {
      const obj = {
        age: this.form.age,
        demoId: this.form.demoId,
        demoName: this.form.demoName,
        editCode: this.form.editCode,
        modifyDate: this.form.modifyDate,
        modifyUser: this.form.modifyUser,
        modifyUserId: this.form.modifyUserId,
        phone: this.form.phone,
        previewCode: this.form.previewCode,
        skuNum: this.form.skuNum,
        skuPrince: this.form.skuPrince,
        status: this.form.status,
        userName: this.form.userName,
        isShowLoading: true
      }
      editDemo(obj).then(res => {
        this.$message({
          message: '编辑成功',
          type: 'success',
          // duration: 3000,
          showClose: true,
          offset: document.body.clientHeight / 2 - 21
        })
        this.$router.push({ path: '/tmpl/demo/demo-list' })
      }).catch(e => {
        console.log(e)
      })
    },
    getDemoById (id) {
      const obj = {
        demoId: id,
        isShowLoading: true
      }
      getDemoById(obj).then(res => {
        console.log(res)
        console.log('detail', res.data)
        this.form = res.data.data
        this.formOrigin = JSON.parse(JSON.stringify(this.form))
      }).catch(e => {
        console.log(e)
      })
    },
    handleBack () {
      this.$router.push({ path: '/tmpl/demo/demo-list' })
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "~@/styles/variables";

  .edit-demo {
  }
</style>
